<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4>Clients</h4>
                <p>Description of clients.</p>
                <DataTable :value="clients" :paginator="true" :rows="10" dataKey="key" :rowHover="true"
                    :selection.sync="selectedRows" :filters="filters" :loading="loading" sortField="name" :sortOrder="1">
                    <template #header>
                        <div class="p-d-md-flex p-jc-md-between">
                            List of Clients
                            <div>
                                <Button label="Delete Selected" icon="pi pi-trash" @click="openMultipleConfirmation"
                                    class="p-button-danger"
                                    v-if="(selectedRows.length && user.data.role.permissionLevel >= 10)" />
                                <span class="p-input-icon-left p-mt-2 p-ml-md-2">
                                    <i class="pi pi-search" />
                                    <InputText v-model="filters['global'].value" placeholder="Client Search" />
                                </span>
                            </div>
                        </div>
                    </template>
                    <template #empty>
                        No clients found.
                    </template>
                    <template #loading>
                        Loading clients data. Please wait.
                    </template>
                    <Column selectionMode="multiple" headerClass="table__button--header" bodyClass="table__button"
                        v-if="(user.data.role.permissionLevel >= 10)"></Column>
                    <Column field="name" header="Name" :sortable="true">
                        <template #body="slotProps">
                            <router-link
                                :to="{ name: 'sites', params: { id: slotProps.data.key } }">{{ slotProps.data.name }}</router-link>
                        </template>
                    </Column>
                    <Column bodyClass="table__button" headerClass="table__button--header"
                        v-if="(user.data.role.permissionLevel >= 10)">
                        <template #body="slotProps">
                            <Button type="button" icon="pi pi-angle-down" @click="toggleMenu($event, slotProps.data.key, slotProps.data)"
                                class="p-button-secondary" />
                        </template>
                    </Column>
                </DataTable>
                <Menu ref="menu" :model="overlayMenuItems.items" :popup="true" />
                <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{ width: '350px' }" :modal="true">
                    <div class="confirmation-content">
                        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
                        <span>Are you sure you want to proceed?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" @click="closeConfirmation(false)" class="p-button-text" />
                        <Button label="Yes" icon="pi pi-check" @click="closeConfirmation(true)" class="p-button-text"
                            autofocus />
                    </template>
                </Dialog>
                <div class="p-d-flex p-jc-end">
                    <Button label="New Client" icon="pi pi-plus" class="p-button-secondary p-mt-3"
                        @click="visibleRight = true" iconPos="right" v-if="(user.data.role.permissionLevel >= 10)" />
                    <Sidebar :visible.sync="visibleRight" :baseZIndex="1000" position="right"
                        v-if="(user.data.role.permissionLevel >= 10)">
                        <h1 style="fontWeight:normal">Add Client</h1>
                        <div class="p-float-label p-my-4">
                            <InputText id="name" type="text" v-model="selected.name" />
                            <label for="name">Client Name</label>
                        </div>
                        <Button type="button" @click="addClient" label="Save" class="p-button-success"
                            style="margin-right:.25em" />
                        <Button type="button" @click="visibleRight = false" label="Cancel" class="p-button-secondary" />
                    </Sidebar>
                </div>
            </div>
        </div>
        <Toast />
    </div>
</template>

<script>
import { db } from '@/firebase';
import { mapGetters } from "vuex";
import { FilterMatchMode } from 'primevue/api';


export default {
    data() {
        return {
            selectedRows: [],
            filters: { global: { value: null, matchMode: FilterMatchMode.CONTAINS } },
            loading: true,
            clients: [],
            selected: {
                name: '',
                key: '',
            },
            multipleDelete: true,
            visibleRight: false,
            displayConfirmation: false,
            overlayMenuItems: {
                id: null,
                items: [
                    {
                        label: 'View/Edit',
                        icon: 'pi pi-pencil'
                    },
                    // {
                    //     label: 'Delete',
                    //     icon: 'pi pi-trash'
                    // },
                ],
            },
        }
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user"
        })
    },
    firestore() {
        return {
            clients: {
                ref: db.collection('clients'),
                resolve: (clientsData) => {
                    clientsData.forEach((client, index) => {
                        db.collection('sites').where('client_id', '==', client.key).onSnapshot((query) => {
                            this.clients[index].siteCount = query.size; // for deletion validation in openConfirmation
                        })
                    })
                    this.loading = false
                }
            }
        }
    },
    methods: {
        toggleMenu(event, id, meta) {
            this.overlayMenuItems = {};
            this.overlayMenuItems = {
                id: id,
                items: [
                    {
                        label: 'View/Edit',
                        icon: 'pi pi-pencil',
                        to: { name: 'sites', params: { id: id } }
                    },
                    {
                        label: 'Delete',
                        icon: 'pi pi-trash',
                        command: (event) => {
                            this.openConfirmation(event, meta)
                        }
                    },
                    {
                        label: 'Edit Settings',
                        icon: 'pi pi-cog',
                        to: { name: 'settings', params: { client_id: id } }
                    },
                ]
            }
            this.$refs.menu.toggle(event);
        },
        openConfirmation(event, meta) {
            if (meta && !meta.siteCount) {
                this.selected = meta;
                this.multipleDelete = false;
                this.displayConfirmation = true;
            } else {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Client still has assigned sites. Remove all sites from this client before deleting.', life: 3000 });
            }
        },
        openMultipleConfirmation() {
            // Check if any selected clients have sites
            const clientsWithSites = this.selectedRows.filter(row => row.siteCount > 0);
            if (clientsWithSites.length > 0) {
                const clientNames = clientsWithSites.map(c => c.name).join(', ');
                this.$toast.add({ severity: 'error', summary: 'Error', detail: `Cannot delete clients with sites: ${clientNames}. Remove all sites from these clients before deleting.`, life: 5000 });
                return;
            }
            this.multipleDelete = true;
            this.displayConfirmation = true;
        },
        closeConfirmation(confirm) {
            if (confirm) {
                if (this.multipleDelete) {
                    let batch = db.batch();
                    this.selectedRows.forEach(item => {
                        var itemRef = this.$firestore.clients.doc(item.key);
                        batch.delete(itemRef)
                    });
                    batch.commit().then(() => {
                        this.selectedRows = [];
                        this.displayConfirmation = false;
                        db.collection('logs').add({
                            activity: 'Multiple clients deleted',
                            timestamp: new Date(),
                            user: this.user.email,
                            client_id: this.user.client.key
                        }).then(() => {
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Multiple clients deleted', life: 3000 });
                        });
                    });
                } else {
                    this.$firestore.clients.doc(this.selected.key).delete().then(() => {
                        this.selected = {};
                        this.selectedRows = [];
                        this.displayConfirmation = false;
                        this.multipleDelete = true;
                        db.collection('logs').add({
                            activity: 'Client deleted',
                            timestamp: new Date(),
                            user: this.user.email,
                            client_id: this.user.client.key
                        }).then(() => {
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Client deleted', life: 3000 });
                        });
                    });
                }
            }
            this.displayConfirmation = false;
        },
        addClient: function () {
            if (this.selected.name != '') {
                this.$firestore.clients.add(
                    {
                        name: this.selected.name,
                        primaryColour: '',
                        secondaryColour: '',
                        timestamp: new Date()
                    }
                ).then(() => {
                    this.selected.name = '';
                    this.visibleRight = false;
                    db.collection('logs').add({
                        activity: 'New client added',
                        timestamp: new Date(),
                        user: this.user.email,
                        client_id: this.user.client.key
                    }).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'New client added', life: 3000 });
                    });
                });
            }
        }
    }
}
</script>

<style scoped lang="scss"></style>
